import React from 'react';
import ContentIconAtom from '@atoms/icon-atoms/content-icon-atoms';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { TriggerAtomProps } from './trigger-atom.types';

const TriggerAtom: React.FC<TriggerAtomProps> = ({
  className,
  buttonText,
  highlightColour,
  action,
}) => {
  if (buttonText && action) {
    return (
      <div
        className={className}
        onClick={action}
        onKeyDown={action}
        role="button"
        tabIndex={0}
        data-testid="trigger-atom"
        data-gtm-id={GTM_ID.TRIGGER_ATOM}
      >
        <span className="button-text">{buttonText}</span>
      </div>
    );
  } else {
    console.warn(
      `Trigger Atom called with missing prop. buttonText: ${buttonText}, action: ${action}`
    );
    return null;
  }
};

const StyledTriggerAtom = styled(TriggerAtom)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${vars.white};
  text-decoration: none;
  padding: 1.4rem ${vars.spacingM};
  height: 4.3rem;
  width: max-content;
  border-radius: 2px;
  .button-text {
    color: ${vars.coreDarkGrey};
    font-weight: ${vars.fontWeightBold};
    ${vars.fontSize2}
    line-height: 1.4;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  ${({ highlightColour }) =>
    highlightColour ? `border: 1px solid ${highlightColour}` : null};
  ${ContentIconAtom} {
    position: relative;
    top: -3px;
    margin-left: 1.2rem;
  }
  &:hover {
    background: ${({ highlightColour }) =>
      highlightColour || vars.coreDarkGrey};
    .button-text {
      color: white;
    }
    cursor: pointer;
    svg {
      fill: white;
      rect {
        fill: none;
      }
    }
  }
`;

export default StyledTriggerAtom;
